import type {
  BasicIconProps,
  SidebarProps,
  SidebarTabProps,
} from "@packages/ui";
import {
  ActivityIcon,
  FriendsIcon,
  ReportIcon,
  SettingsAltIcon,
  UpwardTrendIcon,
} from "@packages/ui";

export const PAD_TABS: (Pick<SidebarTabProps, "actionRight" | "message"> & {
  sidebarState: SidebarProps["state"];
  path: string;
  Icon: (props: BasicIconProps) => JSX.Element;
})[] = [
  {
    Icon: UpwardTrendIcon,
    message: "web_dashboard",
    path: "dashboard",
    sidebarState: "expanded",
  },
  {
    Icon: ActivityIcon,
    message: "intentions_activity",
    path: "activity",
    sidebarState: "expanded",
  },
  {
    Icon: FriendsIcon,
    message: "community_settings_members",
    path: "members",
    sidebarState: "closed",
  },
  {
    Icon: ReportIcon,
    message: "parish_admin_dashboard_navigation_reported",
    path: "reported",
    sidebarState: "expanded",
  },
  {
    Icon: SettingsAltIcon,
    message: "settings_title",
    path: "settings",
    sidebarState: "closed",
  },
];

export const padTabsPaths = PAD_TABS.map(({ path }) => path);
